import React, { PureComponent } from 'react'
import moment from 'moment'
import { image } from 'services'
import classnames from 'classnames'
import style from './style'
import Link from 'next/link'

const icons = {
  'MESSAGE': 'icono-mensaje.png',
  'LEAD': 'icon-person.png',
  'PROPERTY': 'check-ok.png',
  'DIRECT_ANNONCE_LEAD': 'check-ok.png'
}

class Notification extends PureComponent {
  render() {
    const { notification, index } = this.props
    const date = moment(notification.createdAt).format('DD/MM/YY')
    const icon = icons[notification.notificationType]
    const isEven = index % 2 === 0

    return (
      <Link href="/dashboard/notifications">
        <a className="hideOnMobile">
          <div className={classnames("notification-menu-item", {even: isEven})}>
            <img src={image('icons/notifications', icon)} />
            <div className="notification-content">
              <span className="notification-title">
                {notification.sender}
              </span>
              <span className="notification-date">
                {date}
              </span>
            </div>
            <style jsx>{style}</style>
          </div>
        </a>
      </Link>
    )
  }
}

export default Notification
